import { render, staticRenderFns } from "./InventoryTabs.vue?vue&type=template&id=1b3bcc41&scoped=true&"
import script from "./InventoryTabs.vue?vue&type=script&lang=js&"
export * from "./InventoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTabs.vue?vue&type=style&index=0&id=1b3bcc41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3bcc41",
  null
  
)

export default component.exports